import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'entitySelect',
    'countrySelect',
    'currencySelect',
    'sasbIndustrySelect',
    'naceSectorSelect',
  ];

  connect = () => this.syncEntityFields();

  syncEntityFields() {
    const option = this.entitySelectTarget.selectedOptions[0];
    if (!option) return;

    this.#sync('countrySelect', option.dataset.countryId);
    this.#sync('currencySelect', option.dataset.currencyId);
    this.#sync('sasbIndustrySelect', option.dataset.sasbIndustryId);
    this.#sync('naceSectorSelect', option.dataset.naceSectorId);
  }

  #sync(target, value) {
    const capitalized = target.charAt(0).toUpperCase() + target.slice(1);
    if (!this[`has${capitalized}Target`]) return;
    if (value) this[`${target}Target`].value = value;
  }
}
